<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        Bulk Concession Upload
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="12">
            <v-text-field
              :value="concessionType"
              label="Concession Type"
              outlined
              dense
              hide-details="auto"
              readonly
            />
          </v-col>

          <v-col cols="12">
            <v-file-input
              v-model="selectedFile"
              outlined
              dense
              accept=".csv"
              hide-details="auto"
              prepend-inner-icon="mdi-file-upload"
              prepend-icon=""
              label="Upload CSV"
              :rules="[rules.required]"
            >
              <template v-slot:selection="{ text }">
                <span class="text-body-2 text-truncate" style="max-width: 100%">
                  {{ selectedFile ? selectedFile.name : text }}
                </span>
              </template>
            </v-file-input>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="remarks"
              label="Remarks"
              outlined
              dense
              hide-details="auto"
              rows="2"
              :rules="[rules.required]"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn
          class="primary"
          :loading="loading"
          :disabled="!selectedFile || loading"
          @click="upload"
        >
          Upload
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    concessionType: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      rules,
      selectedFile: null,
      remarks: null,
    };
  },

  methods: {
    upload() {
      if (!this.$refs.form.validate()) return;
      if (!this.selectedFile) return;
      this.$emit("upload", this.selectedFile, this.remarks);
    },
  },
};
</script>
